import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { contentApiTypes } from './types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

const TOAST_ID = 'content-edit-material';

export const editContentMaterial = ({
  id,
  managerId,
  ...data
}: contentApiTypes.EditMaterialParams) => {
  return axios.patch(`/content/materials/${id}`, {
    ...(managerId && { managerId }),
    data,
  });
};

type EditContentMaterialOptions = {
  pageId?: string;
  config?: MutationConfig<typeof editContentMaterial>;
};

export const useEditContentMaterial = ({
  pageId,
  config = {},
}: EditContentMaterialOptions = {}) => {
  const { onSuccess, onMutate, onError, ...restConfig } = config;

  return useMutation({
    ...restConfig,
    mutationFn: editContentMaterial,
    onMutate: (variables) => {
      toasts.loadingToast.loading(TOAST_ID, 'Сохранение...');
      return onMutate?.(variables);
    },
    onSuccess: (data, variables, context) => {
      toasts.loadingToast.success(TOAST_ID, 'Материал обновлён');
      if (pageId) {
        queryClient.invalidateQueries(['content-materials', pageId]);
      }
      onSuccess?.(data, variables, context);
    },
    onError: (error: AxiosError<{ error: string }>, variables, context) => {
      toasts.loadingToast.error(TOAST_ID, error.response?.data?.error);
      onError?.(error, variables, context);
    },
  });
};
